export const SHOW_LOADER = 'SHOW_LOADER';
export const REMOVE_LOADER = 'HIDE_LOADER';
